import type { ParticipantAccountStatus } from "@solomon-apps/shared";
import { SectionHeading } from "@solomon-labs/design/components/layout";
import React from "react";

type UnavailableAccountStatus = Exclude<ParticipantAccountStatus, "Active">;

const STATUS_COPY: Record<UnavailableAccountStatus, string> = {
    Pending:
        "This account is not available yet. Contact support if you need help.",
    Suspended: "This account is suspended. Contact support if you need help.",
    Blacklisted:
        "This account cannot use Retail YaaS. Contact support if you need help.",
    Closed: "This account is closed. Contact support if you need help."
};

export function AccountUnavailablePanel({
    status
}: {
    status: UnavailableAccountStatus;
}): React.ReactElement {
    return (
        <section aria-labelledby="account-unavailable-title">
            <SectionHeading variant="h1">
                <span id="account-unavailable-title">Account unavailable</span>
            </SectionHeading>
            <p className="mt-5 text-sm leading-6 text-foreground-muted">
                {STATUS_COPY[status]}
            </p>
        </section>
    );
}
